module.exports = __webpack_public_path__ + "img/baixiaz.ce836d5c.svg";